export default "__VITE_ASSET__4ca4d81f__"